import React from 'react';
import PropTypes from 'prop-types';
import {Button, Header, Modal} from 'semantic-ui-react';

import getMessage from '../../global/getMessage';

const propTypes = {
  amount      : PropTypes.string,
  email       : PropTypes.string,
  onClose     : PropTypes.func.isRequired,
  open        : PropTypes.bool,
  orderNumber : PropTypes.string,
  product     : PropTypes.string,
  lang        : PropTypes.object.isRequired,
};

const defaultProps = {
  amount      : null,
  email       : null,
  open        : false,
  orderNumber : null,
  product     : '',
};

class OrderCompletedModal extends React.PureComponent {

  handleOnClick() {
    window.print();
  }

  render() {
    const {
      amount,
      onClose,
      open,
      orderNumber,
      product,
      email,
      lang,
    } = this.props;

    getMessage('section.choir.content', lang);

    return (
      <Modal
        onClose={onClose}
        open={open}
      >
        <Modal.Header>{getMessage('section.shop.order.title', lang)}</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>{getMessage('section.shop.order.ordernumber', lang)}{orderNumber}</Header>
            <p>
              <b>{getMessage('section.shop.order.productOrdered', lang)}</b>{product}
            </p>
            <p><b>{getMessage('section.shop.order.amount', lang)}</b>{amount}</p>
            <p>{`${getMessage('section.shop.order.emailsent', lang)}${email}`}</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content='Print'
            icon='print'
            labelPosition='right'
            onClick={this.handleOnClick}
          />
          <Button
            content='Close'
            icon='checkmark'
            labelPosition='right'
            onClick={onClose}
            positive
          />
        </Modal.Actions>
      </Modal>
    );
  }

}

OrderCompletedModal.propTypes = propTypes;

OrderCompletedModal.defaultProps = defaultProps;

export default OrderCompletedModal;



// WEBPACK FOOTER //
// ./src/molecules/Product/OrderCompletedModal.js